import React from "react";
import axios from "axios";
import { axiosWithKey } from "~/axios";
import { getToken } from "~/redux/user/tokens";
import userStore from "~/redux/user/store";
import {
	login,
	fbLogin,
	googleLogin,
	signup,
	getCardInfo
} from "~/redux/user/actions";
import jwtDecode from 'jwt-decode'
import getCountryCode from "~/tools/userEnvironment/getCountryCode";
import { userLanguageSelector } from "~/tools/localization";
import { addUserProfile, trackEvent } from "~/tools/analytics/cleverTap";
import Spinner from "~/components/Spinner";
import popup from "../../popup";
import socialHelpers from "../socialHelpers";

import "./style.scss";
import { get, find, value } from "lodash";

import Cookies from "js-cookie";

import AuthCTAButton from "./components/authCtaButton";

export default class View extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeMode: this.props.activeMode ? this.props.activeMode : null,
			emailConsent: {},
			emailChecked: null,
			loading: true,
			metaDataMap: {}
		};

		this.toggleEmailCheck = this.toggleEmailCheck.bind(this);
	}

	getVal(key) {
		return get(this.state.metaDataMap, key);
	}

	componentDidMount() {
		if (this.initializedSocialLogin) return;
		this.initializedSocialLogin = true;
		socialHelpers.initializeFacebookLogin();
		this.fetchEmailConsent();
		this.fetchPageData();
		const { pathname, search } = window.location;
		const args = search
			.slice(1)
			.split("&")
			.map(v => v.split("="))
			.reduce(
				(map, [key, value]) => map.set(key, decodeURIComponent(value)),
				new Map()
			);
		if (pathname === "/sign-up" || args.get("signup") === "true") {
			this.setState({ activeMode: "signup" });
			this.emailInput.value = args.get("email") || "";
		}
	}

	fetchPageData = () => {
		const authNavObj = find(window.settings.navigation.user, function(o) {
			return o.displayedPath === "Authentication Screen";
		});
		const { internalName } = window.settings;
		if (authNavObj) {
			getToken(token => {
				var decodedToken = jwtDecode(token);
		    	var tokenCountryCode = decodedToken.countryCode
				let baseUrl = ""
				if(window.settings.apiBaseUrl === "https://prod-api.viewlift.com") {
					baseUrl = "https://prod-api-cached-2.viewlift.com"
				} else {
					baseUrl = window.settings.apiBaseUrlCached || window.settings.apiBaseUrl
				}
				return axiosWithKey({
					method: "GET",
					url: `${baseUrl}/content/pages?site=${internalName}&path=${
						authNavObj.url
					}&languageCode=${userLanguageSelector()}&includeContent=true&countryCode=${tokenCountryCode}`,
					headers: { Authorization: token }
				})
					.then(res => {
						const response = res.data.modules[0].metadataMap;
						this.setState({ metaDataMap: response, loading: false });
						if (get(window.settings, "socialMedia.googlePlus.signin")) {
							socialHelpers.initializeGoogleLogin(
								this.googleButtonEl,
								this.googleLoginCallback.bind(this)
							);
						}
					})
					.catch();
			});
		}
	};

	fetchEmailConsent() {
		let emailConsentUrl = `https://d2tipiv4cs5bo1.cloudfront.net/emailconsent/${
			window.settings.internalName
		}.json`;
		return axios
			.get(emailConsentUrl)
			.then(r => {
				let emailConsentConfig = r.data;
				return getCountryCode().then(countryCode => {
					let config =
						emailConsentConfig[countryCode] || emailConsentConfig.default || {};
					this.setState({
						emailConsent: config,
						emailChecked: config.checked
					});
				});
			})
			.catch(e => {
				return;
			});
	}

	toggleEmailCheck(e) {
		this.setState({
			emailChecked: e.target.checked
		});
	}

	facebookLogin(e) {
		const element = document.getElementById("ageCheck");
		if (element) {
			const ageCheck = element.checked;
			if (!ageCheck) {
				this.setState({
					ageCheckError: window.settings.features.legal_verbiage_error
				});
				return;
			}
		}

		window.FB.login(
			res => {
				var accessToken =
					res && res.authResponse && res.authResponse.accessToken;
				if (!accessToken) return this.alert(this.getVal("facebookError"));
				this.dispatchLogin(
					fbLogin({
						facebookToken: accessToken,
						emailConsent:
							this.state.activeMode === "signup" &&
							this.state.emailConsent.visible
								? this.state.emailChecked
								: undefined
					}),
					"Facebook"
				);
			},
			{ scope: "email,public_profile" }
		);
	}

	googleLoginCallback(error, googleUser) {
		if (error) return this.alert(this.getVal("googleError"));
		var accessToken = googleUser.getAuthResponse().id_token;
		this.dispatchLogin(
			googleLogin({
				googleToken: accessToken,
				emailConsent:
					this.state.activeMode === "signup" && this.state.emailConsent.visible
						? this.state.emailChecked
						: undefined
			}),
			"Google"
		);
	}

	logIn() {
		if (this.state.loginButtonProgress) return;

		this.setState({ loginButtonProgress: true });

		var creds = {
			email: this.emailInput.value,
			password: this.passwordInput.value
		};

		this.dispatchLogin(login(creds), "Native");
	}

	dispatchLogin(act, loginType) {
		if (this.props.onInitiate) {
			this.props.onInitiate("login");
		}
		userStore
			.dispatch(act)
			.then(_ => {
				var userInfo = userStore.getState().user || {};
				userInfo &&
					addUserProfile("Site", {
						Name: userInfo.name,
						Email: userInfo.email,
						Identity: userInfo.userId,
						"User Status": userInfo.isSubscribed
							? "Subscribed"
							: "Registered and Never Subscribed"
					});

				trackEvent("Login", { platform: "Web", registrationType: loginType });
				userStore.dispatch(getCardInfo(userInfo));

				this.setState({ loginButtonProgress: false });
				popup.hide();
			})
			.catch(error => {
				var errorCode = "";
				this.setState({ loginButtonProgress: false });
				if (error.response.data) {
					errorCode = error.response.data.code;
				}
				var message = this.getVal(errorCode) || this.getVal("defaultError");
				this.alert(message);
				if (this.props.onAuthenticate) {
					this.props.onAuthenticate(false, message);
				}
			});
	}

	signUp() {
		const element = document.getElementById("ageCheck");
		if (element) {
			const ageCheck = element.checked;
			if (!ageCheck) {
				this.setState({
					ageCheckError: window.settings.features.legal_verbiage_error
				});
				return;
			}
		}

		if (this.state.signupButtonProgress) return;

		this.setState({ signupButtonProgress: true, error: "" });

		var user = {
			email: this.emailInput.value,
			password: this.passwordInput.value,
			emailConsent: this.state.emailConsent.visible
				? this.state.emailChecked
				: undefined
		};

		if (this.props.onInitiate) {
			this.props.onInitiate("signup");
		}
		userStore
			.dispatch(signup(user))
			.then(_ => {
				var userInfo = this.props.user;
				userInfo &&
					addUserProfile("Site", {
						Email: userInfo.email,
						Identity: userInfo.userId,
						"User Status": userInfo.isSubscribed
							? "Subscribed"
							: "Registered and Never Subscribed"
					});
				trackEvent("Signed Up", { registrationType: "Native" });
				//The User has successfully Signed Up and we need to save this to open personalization screen when succesfully sign up
				Cookies.set("isUserSignUp", true);
				if (this.props.onAuthenticate) {
					this.props.onAuthenticate(true);
					return false;
				} else if (
					window.settings.serviceType === "SVOD" &&
					!value.isSubscribed
				) {
					if (this.props.args === "FREE" || this.props.args === "AVOD")
						return false;

					window.location.href = "/viewplans";
					return false;
				}
				this.setState({ signupButtonProgress: false });
				popup.hide();
				// console.log("Done signing up");
			})
			.catch(error => {
				this.setState({ signupButtonProgress: false });
				var message =
					this.getVal((((error || {}).response || {}).data || {}).code) ||
					this.getVal("defaultError");
				this.alert(message);
				if (this.props.onAuthenticate) {
					this.props.onAuthenticate(false, message);
				}
			});
	}

	checkCredentialValid() {
		if (!this.passwordInput) return false;

		let password = this.passwordInput.value;

		let passwordIsValid = false;
		let error = "";

		if(password.length >= 5 && password.length <= 50){
			passwordIsValid = true;
		} else {
			error = this.state.metaDataMap.PASSWORD_NOT_VALID;
		}
		
		if(passwordIsValid){
			return true;
		} else {
			this.setState({error: error});
			return false;
		}
	}

	alert(txt) {
		this.setState({ error: txt });
	}

	submitHandler(event) {
		event.preventDefault();
		if (this.state.activeMode) {
			if (this.state.activeMode === "login") {
				this.logIn();
			} else if (this.state.activeMode === "signup") {
				this.signUp();
			}
		}
	}

	ctaClickHandler(type) {
		this.setState({
			error: ""
		});
		if (type === "forget password") {
			popup.newsForgotPassword(this.props.hardwall, this.state.metaDataMap);
		} else if (!this.state.activeMode) {
			this.setState({ activeMode: type });
		} else {
			if (type === "login") {
				if (this.state.activeMode === "login") {
					this.checkCredentialValid() && this.logIn();
				} else {
					this.setState({ activeMode: "login" });
				}
			} else if (type === "signup") {
				if (this.state.activeMode === "signup") {
					this.checkCredentialValid() && this.signUp();
				} else {
					this.setState({ activeMode: "signup" });
				}
			}
		}
	}

	shouldDisableLogin() {
		if (this.state.buttonProgress) return true;
		
		if (this.state.activeMode === 'login')
		  return false
		if (!this.state.emailConsent.visible)
		  return false

		return !this.state.emailChecked
	}

	render() {
		if (this.state.loading)
			return (
				<div className="loading centered">
					<Spinner />
				</div>
			);

		const isSVOD = window.settings.serviceType === "SVOD";
		let showInputs =
			this.state.activeMode && this.state.activeMode !== "forget password";
		const shouldDisableLogin = this.shouldDisableLogin();

		// console.log(this.props);
		// console.log(this.state);

		return (
			<div className="news-auth-view centered">
				<img
					className="logo-image"
					src={get(window.settings, "images.desktopLogo")}
					alt="logo"
				/>
				<div className="auth-body">
					<div className="auth-body-left">
						{this.state.error && (
							<div className="error-messages">{this.state.error}</div>
						)}
						<div className={`auth-form flex-vertical ${showInputs ? "active" : ""}`}>
							<input
								type="email"
								placeholder={this.getVal("emailInput")}
								ref={i => { this.emailInput = i }}
								autoFocus
								required
							/>
							<input
								placeholder={this.getVal("passwordInput")}
								ref={i => {
									this.passwordInput = i;
								}}
								type="password"
								onKeyPress={(e) => {
									if (e.key === "Enter") {
										this.ctaClickHandler(this.state.activeMode)
									}
								}}
								required
							/>
						</div>
						<div className="auth-cta-wrapper flex-vertical">
							<AuthCTAButton
								text={
									this.state.loginButtonProgress
										? this.getVal("loginProcessingCta")
										: this.getVal("loginCta")
								}
								clickHandler={this.ctaClickHandler.bind(this)}
								action="login"
								active={this.state.activeMode === "login"}
							/>
							<AuthCTAButton
								text={
									this.state.signupButtonProgress
										? isSVOD
											? this.getVal("subscribeProcessingCta")
											: this.getVal("signUpProcessingCta")
										: this.getVal("signUpCta")
								}
								clickHandler={this.ctaClickHandler.bind(this)}
								action="signup"
								active={this.state.activeMode === "signup"}
							/>
							<AuthCTAButton
								text={this.getVal("forgotPasswordCtaText")}
								clickHandler={this.ctaClickHandler.bind(this)}
								btnType="button"
								action="forget password"
							/>
						</div>
					</div>
					<div className="or flex-vertical">
						<div className="line1"></div>
						<div className="text">{this.getVal('orSeparator')}</div>
						<div className="line2"></div>
					</div>
					<div className="auth-body-right">
						<div className="social-auth-wrapper">
							<button
								disabled={shouldDisableLogin}
								className="facebook-color-background news-auth-button fat"
								onClick={e => this.facebookLogin(e)}
							>
								{this.state.activeMode === "login"
									? this.getVal("facebookLoginCta")
									: this.getVal("facebookSignUpCta")}
							</button>
							<br />
							{get(window.settings, "socialMedia.googlePlus.signin") && (
								<button
									disabled={shouldDisableLogin}
									className="google-color-background news-auth-button fat"
									ref={el => (this.googleButtonEl = el)}
								>
									{this.state.activeMode === "login"
										? this.getVal("googleLoginCta")
										: this.getVal("googleSignUpCta")}
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
